// extracted by mini-css-extract-plugin
module.exports = {"md":"home-contacts_md_5CIZe","ios":"home-contacts_ios_Kyg4D"};